import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import AnchorCoverTag from '../../StoreHomePage/AnchorCoverTag';
import ImageCoverComponent from '../Common/ImageCoverComponent';
import { calculatePaddingTop, fireClickedCategoryCardEvent } from '../utils';
import {
  SubHeadingDescriptionStyle,
  SubHeadingStyle,
} from './HorizontalVideoSection/styled';
import { DiaperSizeContainer, GeneralSectionCover, ImgWrapper } from './styled';
import { queryParamHandling } from '../../../Utils/productPageUtils';

const DiaperSizeVariants = (props) => {
  const { variantData, categoryId } = props;
  const [cardEffect, setCardEffect] = useState({ index: -1 });
  const { heading, subHeading } = variantData;
  const router = useRouter();
  const callbackFunction = (index, deeplinkValue, clickedVariant) => {
    setCardEffect({ index: index, effect: 'lowOpacity' });
    fireClickedCategoryCardEvent({
      id: categoryId,
      card_name: clickedVariant?.itemName,
      card_id: clickedVariant?.productId,
      section_name: variantData?.itemName,
      section_id: variantData?._id,
      deeplink_value: deeplinkValue,
    });
    setTimeout(() => {
      const { addParams, newUrl } = queryParamHandling(deeplinkValue);
      router.push(`${newUrl}` + addParams, '', {
        locale: getRouterLocale(router),
      });
    }, [200]);
  };

  return (
    <GeneralSectionCover>
      {heading && <SubHeadingStyle>{heading}</SubHeadingStyle>}
      {subHeading && (
        <SubHeadingDescriptionStyle>{subHeading}</SubHeadingDescriptionStyle>
      )}
      <DiaperSizeContainer>
        {variantData?.items?.map((item, index) => {
          const cardSize = item?.size;
          const imageRatioMobile = calculatePaddingTop(
            cardSize == 'NewBorn' ? '7:4' : '27:32',
          );
          {
            //item?.mobileImageRatio
            //item?.desktopImageRatio
          }
          const imageRatioDesktop = calculatePaddingTop(
            cardSize == 'NewBorn' ? '27:32' : item?.desktopImageRatio,
          );
          const mobileImage = item?.image;
          const desktopImage = item?.desktopImage;

          return (
            <ImgWrapper
              key={`category${index}`}
              cardSize={item?.size}
              imageRatioMobile={imageRatioMobile}
              imageRatioDesktop={imageRatioDesktop}
            >
              <AnchorCoverTag
                url={item?.webUrl}
                cardEffect={cardEffect.index === index ? 'lowOpacity' : ''}
                callbackFunction={callbackFunction}
                index={index}
                element={item}
              >
                <ImageCoverComponent
                  imageRatioMobile={imageRatioMobile}
                  imageRatioDesktop={imageRatioDesktop}
                  mobileImage={mobileImage}
                  desktopImage={desktopImage}
                />
              </AnchorCoverTag>
            </ImgWrapper>
          );
        })}
      </DiaperSizeContainer>
    </GeneralSectionCover>
  );
};

export default DiaperSizeVariants;
